import React from 'react';

import { styled } from '@linaria/react';
import { useTheme } from 'src/theme';

import successIcon from '@assets/icon/valid-message.svg';
import errorIcon from '@assets/icon/invalid-message.svg';

export interface BulletProps {
  variant?: 'default' | 'success' | 'error' | 'alphabet' | 'roman';
  bottomMargin?: 'default' | 'big' | 'small';
  topMargin?: number | string;
  label?: string;
  className?: string;
  theme?: any;
  children?: React.ReactNode;
  size?:string;
  letterSpacing?: number;
}

const OuterContainer = styled.div<BulletProps>`
  display: block;
  margin: ${props => props.topMargin + 'px'} 0 ${props => (props.bottomMargin === 'small') ? 5 :
  (props.bottomMargin === 'big' ? 15 : 10)}px;
  padding: 0 0 0 ${props => (props.variant === 'success' || props.variant === 'error') ? 35 : 30}px;
  position: relative;

  color: ${props => props.variant === 'success' ? props.theme.colors.green[200] :
  props.variant === 'error' ? props.theme.colors.red[200] : props.theme.colors.grey[500]};
  font-family: ${props => props.theme.fontFamily};
  font-weight: ${props => (props.variant === 'success' ||
    props.variant === 'error') ? 600 : 'normal'};
  line-height: 1.5;
  letter-spacing: ${props => props.letterSpacing ? props.letterSpacing : '-0.1px'};
  font-size: 16px;
  text-align: left;
  word-break: break-word;
  & p {
    color: ${props => props.variant === 'success' ? props.theme.colors.green[200] : props.theme.colors.grey[500]};
    font-weight: ${props => (props.variant === 'success' || props.variant === 'error') ? 600 : 'normal'};
  }
`;

const CircleIcon = styled.span<BulletProps>`
  display: inline-block;
  background-color: #5c596d;
  width: ${props=>props.size ? props.size : "7px"};
  height: ${props=>props.size ? props.size : "7px"};
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 9px;
`

const ImageIcon = styled.img<BulletProps>`
  display: inline-block;
  width: 25px;
  height: 25px;
  position: absolute;
  left: 0;
  top: -2px;
`

const TextIcon = styled.span<BulletProps>`
  display: inline-block;
  font-family: ${props => props.theme.fontFamily};
  font-size: 16px;
  font-weight: bold;
  letter-spacing: -0.1px;
  color: #444444;
  width: 7px;
  height: 7px;
  position: absolute;
  left: 0;
  top: 0;
  white-space: nowrap;
` 

function Bullet({
  variant = 'default',
  children,
  topMargin = '0',
  bottomMargin = 'default',
  className = '',
  label,
  size,
  letterSpacing,
  ...props
}: BulletProps) {
  const theme = useTheme();

  return <OuterContainer className={className} theme={theme} variant={variant} bottomMargin={bottomMargin} topMargin={topMargin} letterSpacing={letterSpacing}>
    {variant === 'default' ? <CircleIcon size={size}/> : null}
    {variant === 'success' ? <ImageIcon src={successIcon}/> : null}
    {variant === 'error' ? <ImageIcon src={errorIcon} /> : null}
    {variant === 'alphabet' || variant === 'roman' ? <TextIcon theme={theme}>{label}</TextIcon> : null}
    {children}
  </OuterContainer>;
};

Bullet.defaultProps = {
  variant: 'default'
}

export default Bullet;
